import { render, staticRenderFns } from "./Strategic.vue?vue&type=template&id=8ad1c6ee&"
import script from "./Strategic.vue?vue&type=script&lang=js&"
export * from "./Strategic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports